import React from 'react';
import LegalLayout from '../../components/LegalLayout';
import { ENTREPRISE as E } from '../../data/entreprise';

const Ligne = ({ label, children }) => (
  <p><strong>{label} :</strong> {children}</p>
);

const MentionsLegales = () => (
  <LegalLayout
    titre="Mentions légales"
    description="Mentions légales du site surophone.fr – Suro Phone, réparation iPhone et Samsung à Saint-Chamond (Loire)."
    path="/mentions-legales"
  >
    <h2>Éditeur du site</h2>
    <Ligne label="Nom commercial">{E.nom}</Ligne>
    <Ligne label="Responsable de la publication">{E.responsable}</Ligne>
    <Ligne label="Forme juridique">{E.formeJuridique}</Ligne>
    <Ligne label="SIREN">{E.siren}</Ligne>
    <Ligne label="SIRET">{E.siret}</Ligne>
    <Ligne label="N° TVA intracommunautaire">{E.tva}</Ligne>
    <Ligne label="Code APE">{E.ape}</Ligne>
    <Ligne label="Adresse">{E.adresse}</Ligne>
    <Ligne label="Téléphone"><a href={E.telLien} data-testid="legal-tel">{E.telAffiche}</a></Ligne>
    <Ligne label="Site">{E.site}</Ligne>

    <h2>Hébergement</h2>
    <p>
      Le site est hébergé par <strong>{E.hebergeur.nom}</strong> — <a href={E.hebergeur.site} target="_blank" rel="noopener noreferrer">{E.hebergeur.site}</a>.
    </p>

    <h2>Propriété intellectuelle</h2>
    <p>
      L'ensemble des contenus de ce site (textes, visuels, logo, structure) est la propriété de {E.nom}, sauf mention contraire. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.
      iPhone et Apple sont des marques d'Apple Inc. ; Samsung et Galaxy sont des marques de Samsung Electronics. {E.nom} est un réparateur indépendant, non affilié à ces marques.
    </p>

    <h2>Responsabilité</h2>
    <p>
      Les informations publiées sur ce site sont fournies à titre indicatif. {E.nom} s'efforce d'en assurer l'exactitude mais ne saurait être tenu responsable des erreurs ou omissions, ni de l'utilisation faite de ces informations. Tout devis communiqué par téléphone ou WhatsApp est confirmé après diagnostic de l'appareil.
    </p>

    <h2>Données personnelles</h2>
    <p>
      Les données collectées via le formulaire de rendez-vous sont traitées conformément à notre <a href="/politique-de-confidentialite">politique de confidentialité</a>.
    </p>

    <h2>Médiation de la consommation</h2>
    <p>
      Conformément aux articles L.611-1 et suivants du Code de la consommation, le client consommateur peut recourir gratuitement à un médiateur de la consommation en cas de litige non résolu directement avec {E.nom}.
    </p>
  </LegalLayout>
);

export default MentionsLegales;
